'use client';

import { ReactNode } from 'react';
import { useLinkClickLog } from '@/hooks/use-link-click-log';
import { PageViewLogger } from '@/components/page-view-logger';
import Demo7Layout from '../components/layouts/demo7/layout';

export default function PublicLayout({
    children,
}: {
    children: ReactNode;
}) {
    useLinkClickLog();

    return (
        <>
            <PageViewLogger />
            <Demo7Layout>{children}</Demo7Layout>
        </>
    );
}
